// extracted by mini-css-extract-plugin
module.exports = {"container":"room-options-module__container___LLYmB","title":"room-options-module__title___5LNrh"};